import { ToastType } from '@core/components/toast/toast.models'

export const ToastIconMapping = {
  [ToastType.Success]: 'check',
  [ToastType.Info]: 'info-circle',
  [ToastType.Warning]: 'exclamation-triangle',
  [ToastType.Error]: 'times',
}
